module.exports = __webpack_public_path__ + "img/btn-swiper-play-control-02.6d4c3045.svg";